import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import * as dayjs from 'dayjs';
import { ExternalRequestModel } from 'src/app/models/external-request.model';
import { AdditionalFormField } from 'src/app/models/request-header.model';
import { MenuCategory, MenuItem, MenuSection } from 'src/app/models/rich-data.model';
import { SalesHeader, SalesLine } from 'src/app/models/sales-header.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AuthService } from 'src/app/services/auth.service';
import { CartService } from 'src/app/services/cart.service';
import { DataService } from 'src/app/services/data.service';
import { GetTranslationService } from 'src/app/services/get-translation.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { RequestService } from 'src/app/services/request.service';
import { ScheduledCartService } from 'src/app/services/scheduled-cart.service';
import { ToastMachineService } from 'src/app/services/toast-machine.service';
@Component({
  selector: 'app-shceduled-cart-note',
  templateUrl: './shceduled-cart-note.component.html',
  styleUrls: ['./shceduled-cart-note.component.scss', '../scheduled-cart/scheduled-cart.component.scss']
})
export class ShceduledCartNoteComponent implements OnInit {

  @Input() menuItem: MenuItem;
  @Input() menuSection: MenuSection;
  @Input() menuCategory: MenuCategory;
  @Input() orderDate: string;
  @Input() orderTime: string;
  orderDateTime: string;
  isoOrderDate: string;
  capacityName: string;
  name: string;
  noteInput: string;


  constructor(
    public authServ: AuthService,
    public dataServ: DataService,
    public cartServ: CartService,
    private analytics: AnalyticsService,
    private caption: CaptionPipe,
    private requestServ: RequestService,
    public alertCtrl: AlertController,
    private mdlctrl: ModalController,
    private router: Router,
    private toaster: ToastMachineService,
  ) { }

  ngOnInit() {
    const formattedDate = this.orderDate.replace(/\//g, '-');
    this.orderDateTime = dayjs(new Date(`${formattedDate}T${this.orderTime}`)).toISOString();

    const splittedDate = this.orderDate.split('/');
    this.isoOrderDate = splittedDate[2] + '/' + splittedDate[1] + '/' + splittedDate[0];
  }


  async close() {
    await this.mdlctrl.dismiss();
  }

  async closeAll() {
    await this.mdlctrl.dismiss();
    await this.mdlctrl.dismiss();
  }

  isFormFieldsValid(): boolean {

    let result = true;
    this.dataServ.menuItem.form_fields?.forEach((formField) => {
      if (formField.is_required && formField.value === undefined) {
        result = false;
      }
    });

    return result;
  }

  async send() {
    if (this.menuItem.profile_is_not_required && ((!this.capacityName) || (this.menuItem.profile_is_not_required && !this.authServ.isLogged && !this.name) || (!this.isFormFieldsValid()))) {
      const MSG = 'Please fill all required fields.';
      this.toaster.toastMachine(MSG, 'danger', 3000);
      return;
    }
    try {
      const ORDERTIME = this.orderDateTime;

      if (this.menuItem.profile_is_not_required && !this.authServ.isLogged) {
        const externalRequest = new ExternalRequestModel();

        if (this.menuItem.form_fields && this.menuItem.form_fields.length > 0) {
          externalRequest.additional_form_fields = [];
          for (const form of this.menuItem.form_fields) {
            const FIELD = new AdditionalFormField(form);
            externalRequest.additional_form_fields.push(FIELD);
          }
        }

        externalRequest.hotel_id = this.menuItem.hotel_id;
        externalRequest.profile_name = this.name;
        externalRequest.phone_no = '';
        externalRequest.capacity_name = this.capacityName;
        externalRequest.menu_item_id = this.menuItem.id;
        externalRequest.order_date = new Date(ORDERTIME);
        externalRequest.note = this.noteInput;
        externalRequest.amount = 0;
        externalRequest.locale = localStorage.getItem('userLang');


        await this.cartServ.externalRequest(externalRequest);
      }

      if (this.dataServ.menuItem.mobile_payment && this.authServ.isLogged) {
        const PAYMENTTYPE = await this.requestServ.getPaymentProvider();


        //PAYMENT TİPİ GPE PAY İSE
        if (PAYMENTTYPE.name === 'GPEPay' || PAYMENTTYPE.name === 'BULUTTahsilat') {

          const REQUEST = await this.cartServ.request(ORDERTIME, this.noteInput, this.menuSection, this.menuItem, sessionStorage.getItem('tableNo'), 'paymentProcessing');

          REQUEST.payment_type = 'Online';

          // SALES HEADER
          const SALESHEADER = new SalesHeader(REQUEST, this.authServ.profile, this.dataServ.rData);
          SALESHEADER.currency =
            REQUEST.requestlines[0].currency_code == 'TL' ? 'TRY' :
              REQUEST.requestlines[0].currency_code == '$' ? 'USD' :
                REQUEST.requestlines[0].currency_code == '€' ? 'EUR' :
                  REQUEST.requestlines[0].currency_code == '£' ? 'GBP' : 'TRY';
          SALESHEADER.payment_method_code = 'CreditCard';
          SALESHEADER.invoice_discount_calculation = 'None';


          for (const [INDEX, ITEM] of REQUEST.requestlines.entries()) {

            // const CARTITEM = this.carcart.find(x => x.size.menu_item_catalog_id === ITEM.request_type_id);
            const CARTITEM = this.cartServ.cart.find(x => x.size.menu_item_catalog_id === ITEM.request_type_id);

            let discount: {
              type: 'None' | '%' | 'LineAmount';
              discountAmount: number;
              basePrice: number;
              invoiceDiscount: number;
            } = null;

            if (CARTITEM) {
              discount = {
                type: CARTITEM.discountType || 'None',
                discountAmount: CARTITEM.discountAmount,
                basePrice: CARTITEM.basePrice * CARTITEM.size.quantity,
                invoiceDiscount: 0
              };
            } else {
              discount = {
                type: 'None',
                discountAmount: 0,
                basePrice: ITEM.amount,
                invoiceDiscount: 0
              };
            }
            const SALESLINE = new SalesLine(REQUEST, ITEM, this.authServ.profile, INDEX + 1, discount, 0);
            SALESLINE.type = 'Item';
            SALESHEADER.sales_lines.push(SALESLINE);
          }

          SALESHEADER.sales_lines?.forEach(line => {
            SALESHEADER.invoice_amount += line.line_amount;
          });

          if(SALESHEADER.invoice_amount < this.menuItem.free_service_over_amount) {
            SALESHEADER.invoice_amount = SALESHEADER.invoice_amount + this.menuItem.service_charge;
          }

          SALESHEADER.redirect_success_url = window.location.origin + '/payment-successfull';

          SALESHEADER.redirect_un_success_url = window.location.origin + '/payment-failed';

          const IFRAMEURLBASE64 = await this.requestServ.sendSale(SALESHEADER);

          const IFRAMEURL = atob(IFRAMEURLBASE64.pay_url);

          this.analytics.eventEmitter(
            `${this.caption.transform(this.dataServ.menuItem.name, this.dataServ.rData.hotel_language || 'tr')}_buy`,
            'button', 'click', `${this.caption.transform(this.dataServ.menuItem.name, this.dataServ.rData.hotel_language || 'tr')}_buy`,
            this.dataServ.menuItem.id);

          window.location.href = IFRAMEURL;

          //target blank
          // window.open(IFRAMEURL, '_blank');

          // this.modalServ.showPaymentModal(IFRAMEURL);

        }

      } else if (this.authServ.isLogged) {

        await this.cartServ.request(ORDERTIME, this.noteInput, this.menuSection, this.menuItem, sessionStorage.getItem('tableNo'));

      }
      const URL = this.router.url.split('/');

      URL.shift();


      this.analytics.eventEmitter(
        `${this.caption.transform(this.dataServ.menuItem.name, this.dataServ.rData.hotel_language || 'tr')}_buy`,
        'button', 'click', `${this.caption.transform(this.dataServ.menuItem.name, this.dataServ.rData.hotel_language || 'tr')}_buy`,
        this.dataServ.menuItem.id);


      const routeUrl = '/' + URL[0];
      this.router.navigateByUrl(routeUrl);
      this.closeAll();


    } catch {
    }
  }

}
